import axios from 'axios';

const axiosInstanceAI = axios.create({
  baseURL: `${import.meta.env.VITE_AI_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: (status) => status >= 200 && status < 300,
});

export default axiosInstanceAI;
